import { AttendanceConstants as Constants } from '../types'

const initialState = {
    attendance: [],        
    total: 0,
    error: null,    
    loading: false   
};

export function attendanceReducer(state = initialState, action) {
    switch (action.type) {  

        case Constants.GET:                     
            return {
                ...state,
                attendance: action?.payload?.attendance,
                total: action?.payload?.total,
                loading: false,
                error: null,
            };


        case Constants.UPDATE:                     
            const index = state.attendance.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.attendance?.id))
            const newArray = [...state.attendance];
            if(index > -1)
                newArray[index] = action?.payload?.attendance
            return {
                ...state,
                attendance: newArray,
                error: null,
            }   
        
                       

        
        case Constants.DELETE:
            return{
                ...state,
                fees: state?.attendance?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
            return{
                ...state,
                attendance: []
            }
        default:
            return state
    }
}